export default class RecordsHallOfFame
{
	type = null
	classes = {}

	constructor(type)
	{
		this.type = type;

		if(type != 'handicapped')
		{
			this.classes['A'] = new RecordsHallOfFame.RecordClass();
			this.classes['B'] = new RecordsHallOfFame.RecordClass();
			this.classes['C'] = new RecordsHallOfFame.RecordClass();
			this.classes['D'] = new RecordsHallOfFame.RecordClass();
			this.classes['E'] = new RecordsHallOfFame.RecordClass();
		}
		this.classes['F'] = new RecordsHallOfFame.RecordClass();
		this.classes['G'] = new RecordsHallOfFame.RecordClass();
		this.classes['H'] = new RecordsHallOfFame.RecordClass();
		this.classes['I'] = new RecordsHallOfFame.RecordClass();
		this.classes['J'] = new RecordsHallOfFame.RecordClass();
		this.classes['K'] = new RecordsHallOfFame.RecordClass();
		this.classes['L'] = new RecordsHallOfFame.RecordClass();
		this.classes['M'] = new RecordsHallOfFame.RecordClass();
		this.classes['N'] = new RecordsHallOfFame.RecordClass();
		this.classes['O'] = new RecordsHallOfFame.RecordClass();
	}

	static RecordClass = class {
		currentRecord = null
		allRecords = []

		get isVacant()
		{
			return !this.currentRecord;
		}

		get altitudeToBeat()
		{
			if(!this.currentRecord)
			{
				if(this.allRecords.length > 0)
					// 15% leeway for vacant records
					return this.allRecords[0].altitude * 0.85
				
				return 0;
			}

			if(this.allRecords.length > 0)
					return this.allRecords[0].altitude
				
			return 0;
		}

		get minRequiredAlt()
		{
			if(this.allRecords.length > 0)
				return this.allRecords[0].altitude * 0.85
				
			return 0;
		}

		get history()
		{
			return this.allRecords.filter(r => !r.equals(this.currentRecord))
		}
	}

	static Record = class {
		userId = null
		userName = null
		userAvatar = null
		
		rocketId = null
		flightId = null
		
		flownOn = null
		recordClass = null
		altitude = null
		location = null

		rocketName = null
		rocketDiameter = 0
		rocketMass = 0
		rocketMotors = null

		altimeter = null

		equals(other)
		{
			return !!other && this.userId == other.userId && this.userName == other.userName && this.recordClass == other.recordClass && this.altitude == other.altitude;
		}
	}

	addRecord(userId, rocketId, flightId, userName, userAvatar, teamName, flownOn, recordClass, altitude, location, rocketName, rocketDiameter, rocketMass, rocketMotors, altimeter)
	{
		let record = new RecordsHallOfFame.Record();
		record.userId = userId;
		record.rocketId = rocketId,
		record.flightId = flightId,
		record.userName = userName;
		record.userAvatar = userAvatar;
		record.teamName = teamName;
		record.flownOn = flownOn;
		record.recordClass = recordClass;
		record.altitude = altitude;
		record.location = location;
		record.rocketName = rocketName;
		record.rocketDiameter = rocketDiameter;
		record.rocketMass = rocketMass;
		record.rocketMotors = rocketMotors;
		record.altimeter = altimeter;

		// classes[].currentRecord might be null, in the case of a vacant record

		let currentRecord = this.classes[recordClass].allRecords?.[0]

		// handle importing
		let realUserId = !userId.startsWith('UNKNOWN_')

		if(realUserId)
		{
			if(!currentRecord || record.altitude > currentRecord.altitude)
				this.classes[recordClass].currentRecord = record;
		}
		//else
		//	this.classes[recordClass].currentRecord = null

		this.classes[recordClass].allRecords.push(record);
		this.classes[recordClass].allRecords.sort((a, b) => b.altitude - a.altitude)
	}
}